/**多語言配置說明 https://segmentfault.com/a/1190000014229902 */
//韩国
export const lang ={
  Please_set_materialtype_in_product_page:"각 제품 - 완제품 - 반제품 - 부속품의 재질 유형을 수정 및 설정하려면 제품 페이지로 이동하십시오.",
deleteAccount:"로그 아웃",
deleteAccountWillDeleteAllData:"계정에서 로그아웃하면 모든 데이터가 삭제되고 로그인할 수 없게 됩니다.",
backupDatabase:"백업 데이터베이스",
restoreDatabase:"데이터베이스 복원",
materialtype:"재료 유형",
Manufacturing:"제조 버전",
Professional:"프로페셔널 버전",
Standard:"스탠다드 에디션",
product:"완제품",
halfProduct:"반제품",
components:"부속품",
Parent:"상위 구성 요소",
Children:"하위 액세서리",
Level:"계층",
Timing:"타이밍",
PieceCount:"작품수",
Wages:"임금",
InternalProcess:"내부 프로세스",
ExternalProcess:"외부 프로세스",
ProceName:"프로세스 이름",
ProceIndex:"실행 순서",
ChargeMan:"주요한",
BillMethod:"청구방법",
ConsumTime:"근무시간",
Accessories:"부속품",
Assembly:"모으다",
materials:"재료",
task:"일",
process:"프로세스",
BOM:"BOM",
Production:"생산",
RestorePurchaseOneUse:"구매 복원(사용자 1명(이전 구매에 한함))",
buy_fail_try_again:"구매를 원하시면 다시 클릭해주세요",
Export:"내보내다",
Date:"날짜",
BankDetail:"은행 계좌 정보",
Seller:"파는 사람",
Buver:"사는 사람",
Currency:"통화",
CompanyName:"회사 이름",
ProformaInvoice:"견적 송장",
Discount:"할인",
PayStatus:"지불 상태",
ShippingStatus:"배송상태",
FreightType:"운송 유형",
Shipping:"화물",
Payment:"지불",
Moneyname:"통화 이름",
Tax:"구실",
Freight:"운임",
Insurance:"보험",
Bankfee:"은행 수수료",
Qc:"품질인증",
Exchangerate:"환율",
Shippingnumber:"운송 번호",
ShipDate:"선박 날짜",
Arrivedate:"도착 일",
Grossweight:"총 중량",
CubicWeight:"입방 중량",
Totalpackages:"총 패키지 수",
Moneytype:"통화 유형",
Quotedate:"견적 날짜",
Validitydate:"유효한 날짜",
Paymentterm:"급여 만료",
Priceterm:"가격 기간",
DeliveryTerm:"배달 시간",
BankName:"은행 이름",
BankAddress:"계좌 번호",
SwiftCode:"은행 코드",
Review:"검토",
Signfor:"영수증 서명",
Finance:"재원",
Receiver:"수화기",
Business:"사업",
ContactPerson:"담당자",
Profit:"이익",
Staff_must_use_in_browser_please_check_the_address_in_help_page:"직원은 반드시 구글 크롬을 사용해야 하며, 메인 서비스 컴퓨터 APP의 도움말 페이지에서 IP 주소를 확인하신 후, 다른 컴퓨터 브라우저의 URL 열에 주소를 입력하시면 로그인이 가능합니다.",
newPassword:"새 비밀번호",
ForgetPassword:"비밀번호를 잊어버려",
ContactUs:"문의/제안",
Actualpay_should_big_then_shouldpay:"실제 수령액은 미수금보다 클 수 없습니다.",
ShopAddress:"내 매장 주소 QR 코드를 스캔하여 주문하세요",
Submit:"제출하다",
All:"모두",
OrdernumExists:"주문 번호가 이미 존재합니다.",
PermissionDenied:"허가가 거부되었습니다",
StockTransfer:"재고양도",
FromWarehouse:"창고 밖으로 이동",
ToWarehouse:"창고로 이동",
PleaseUseInWebBrowser:"구글 크롬에서 엑셀 내보내기 기능을 이용해 보세요",
PleasePrintInWebBrowser:"구글 크롬에서 인쇄 기능을 이용해 보세요",
HistoryPrice:"역사적 가격",
SerialNumber:"일련번호",
Please_Use_In_APP:"컴퓨터 소프트웨어 내에서 사용하십시오.",
Please_Purchase_In_APP:"브라우저가 아닌 앱 내에서 구매하세요.",
Connect_Postgresql_database_Default_database_is_sqlite_in_local:"Postgresql 데이터베이스에 연결할 수 있습니다. 데이터는 Postgresql 데이터베이스에 저장됩니다. 기본적으로 Postgresql 데이터베이스에 연결할 필요가 없습니다. 기본값은 로컬 Sqlite 데이터베이스입니다.",
Connect_Postgresql_database_data_will_store_in_Postgresql:"Postgresql 데이터베이스에 연결하면 데이터가 Postgresql 데이터베이스에 저장되고 데이터를 다시 읽습니다.",
Use_sqlite_data_will_store_in_local:"sqlite를 사용하면 데이터가 로컬 컴퓨터에 저장됩니다.",
UsePostgresqlDatabase:"PGSQL 데이터베이스 사용",
UseSqliteDatabase:"SQLite 데이터베이스 사용",
DatabaseName:"데이터베이스 이름 지정",
Test_connect:"테스트 연결",
If_has_color_size_initstock_input_0_and_then_add_it_in_purchase:"상품에 색상이나 사이즈가 있는 경우 초기재고를 0으로 채워주시고, 상품추가 후 구매에 재고를 입력해주세요.",
my:"내 거",
my_shop_qrcode_scan:"내 매장의 QR 코드는 고객에게 코드를 스캔하여 주문할 수 있는 기능을 제공합니다. 고객의 휴대폰은 컴퓨터와 동일한 라우터에 연결되어 있어야 합니다.",
ip:"IP",
port:"포트",
orderstatus:"주문 상태",
image:"그림",
Template:"주형",
Please_select_a_excel_file:"파일을 선택하세요",
Please_select_only_one_excel_file:"파일은 하나만 선택할 수 있습니다.",
Connect_Internet_Login_again:"구매하기 전에 인터넷에 연결하고 다시 로그인하세요.",

    productHasValidDate:'제품의 유효 기간이 있습니다.',
productHasColor:'제품에 색상 크기가 있습니다.',
GeneralGoods:'일반 상품',
Selected:'선택됨',
RestorePurchase:'구매 재개',
Buy_ElinkInvoice_Enterprise_Edition_OneUser:'인보이스 발행 Enterprise Edition 1 사용자 영구 구매',
Buy_ElinkInvoice_EnterpriseEdition_Unlimited_Users:'구매 인보이스 발행 Enterprise Edition은 사용자 및 장치에 무제한입니다.',
Purchasing:'구매 중 ... 기다려주세요.',
Validdate:'유효 기간',
Makedate:'생산 날짜',
Batch:'일괄 처리',
CheckVersion:'버전 확인',
Please_set_this_ip_address_on_App:'APP에있는 컴퓨터의 IP 주소 또는 IP 주소를 설정하십시오.',
Open_this_link_on_other_Computer_and_Phone_connect_the_same_WiFi:'이 연결을 컴퓨터 또는 모바일 브라우저에서 엽니 다 (동일한 WiFi 연결).',


    CheckVersion:'버전 확인',
    You_need_to_purchase :'아직 구매하지 않았습니다. WeChat을 Elink9988 이메일에 추가하십시오 : bvbuy@qq.com',
Thank_for_your_purchase : '이미 구입하셨습니다',
New_version_available : '새 버전이 있습니다',
Is_the_latest_version : '최신 버전 입니다.',
    please:'부디',
input:'입력',
wrong:'잘못된',
Verifycode:'코드 확인',
Upload:'업로드',
Download:'다운로드',
You_need_to_purchase_to_continue_use:'계속 사용하려면 구입해야합니다.',
CheckBuy:'구매 확인',
Exists:'존재한다.',
NetworkUnavailable:'네트워크를 사용할 수 없음',
Today:'오늘',
Yesterday:'어제',
ThisMonth:'이번 달',
LastMonth:'지난 달',
nickname:'닉네임',
storeName:'가게 이름',
BuyStandAlone:'독립 실행 형 버전 구입',
PermissionDenied:'사용 권한이 거부되었습니다.',
Boss:'Boss',
    login:'로그인',
    operate:'운영하다',
    register:'레지스터',
    username:'사용자 이름',
    password:'암호',
    User:'사용자',
    ok:'승인',
    back:'뒤로',
    success:'성공',
    fail:'실패',
    cancel:'취소',
    add:'더하다',
    edit:'편집하다',
    delete:'지우다',
    refresh:'새롭게 하다',
    close:'닫기',
    cancel:'취소',
    return:'반환',
    ElinkInvoice:'엘킹 인보이스',
    Purchase:'매수',
    BaseData:'BaseData',
    Sell:'팔다',
    PurchaseReturns:'구매 반품',
    SellReturns:'반품 판매',
    Inventory:'목록',
    Statistics:'통계',
    Receivable:'받을 수 있는',
    Payable:'지불 가능',
    Orders:'명령',
    StockTransfer:'재고 이전',
    StockRecall:'주식 리콜',
    Customer:'고객',
    Supplier:'공급자',
    Warehouse:'창고',
    Color:'색깔',
    Size:'크기',
    Category:'범주',
    Category2:'카테고리 2',
    Product:'생성물',
    Account:'계정',
    AccountType:'계정 카테고리',
    Staff:'직원',
    typeone:'범주',
    typetwo:'하위 카테고리',
    ProductName:'상품명',
    Specification:'사양',
    Barcode:'바코드',
    Buyprice:'구매 가격',
    Sellprice:'판매 가격',
    Wholesaleprice:'도매 가격',
    Currentstock:'현재 재고',
    Unit:'단위',
    Initstock:'초기 재고',
    Parameter:'매개 변수',
    Remark:'말',
    Supplier:'공급자',
    Customer:'고객',
    Staff:'직원',
    Receivable:'받을 수 있는',
    payable:'지불할만한',
    Receipts:'영수증',
    Paid:'유료',
    Preferential:'우대',
    DateDay:'날짜',
    OrderNum:'주문 번호',
    Name:'이름',
    UserName:'사용자 이름',
    IdNum:'ID 번호',
    BirthDay:'생일',
    SEX:'섹스',
    Female:'여자',
    Male:'남성',
    Select:'고르다',
    Address:'주소',
    Phone:'전화',
    Email:'이메일',
    CardNum:'카드 번호',
    Price:'가격',
    QTY:'수량',
    SupplierCategory:'공급 업체 카테고리',
    CustomerCategory:'고객 카테고리',
    Power:'힘',
    Role:'역할',
    save:'구하다',
    image:'영상',
    search:'수색',
    Year:'년',
    Month:'달',
    Day:'일',
    Total:'합계',
    WorkReport:'작업 보고서',
    Leave:'휴가',
    CheckIn:'체크인',
    Announcement:'발표',
    Approval:'승인',
    Tracking:'추적',
    Bill:'계산서',
    OrdersDetail:'주문 세부 정보',
    Expense:'비용',
    Income:'수입',
    Userfor:'사용자',
    Amount:'양',
    Title:'표제',
    News:'뉴스',
    SelectFile:'선택 파일',
    Content:'함유량',
    Cost:'비용',
    ApprovalUser:'승인 사용자',
    ApprovalStatus:'승인 상태',
    ApprovalRemark:'승인 비고',
    ApprovalDate:'승인일',
    SubmitDate:'제출 날짜',
    Status:'지위',
    FromDateTime:'날짜 시간부터',
    ToDateTime:'날짜 시간',
    Subject:'제목',
    Latitude:'위도',
    Longitude:'경도',
    Print:'인쇄',
    DataTrans:'DataTrans',
    OA:'OA 기기',
    Setting:'환경',
    Help:'도움',
    ScanOpenInPhone:'전화에서 스캔 열기',
    Building:'건물',
    Room:'방',
    HotelCheckIn:'체크인',
    CheckOut:'체크 아웃',
    Hotel:'호텔',
    Checkintime:'제 시간에 확인하다',
    Checkouttime:'체크 아웃 시간',
    Deposit:'예금',
    Cost:'비용',
    RoomNum:'방 번호',
    Rent:'임대',
    costday:'비싼 날',
    rent:'임대',
    waternum:'수위',
    electricnum:'전기 학위',
    gasnum:'가스 학위',
    watercost:'물 비용',
    electriccost:'전기 요금',
    gascost:'가스 비용',
    cleaningcost:'청소 비용',
    networkcost:'네트워크 비용',
    tvcost:'TV 비용',
    managecost:'비용을 관리하다',
    othercost:'기타 비용',
    totalcost:'총비용',
    remark:'말',
    addtime:'addtime',
    OpenInBrowser:'브라우저에서 열려',
    InventoryProfit:'재고 이익',
    InventoryLoss:'재고 손실',
    Buy:'사다',
    Refresh:'새로고침',
    Add:'추가',
    Search:'검색',
    Records:'건',

    }



// WEBPACK FOOTER //
// ./src/lang/ko-KR.js